// extracted by mini-css-extract-plugin
module.exports =  {"customCol":"customCol__2tFI9","colOffset":"colOffset__T1Kcm","menu":"menu__WSsXB","deleteBtn":"deleteBtn__dS0eL"};